import { useCallback, useState } from 'react'
import type { CustomFieldFormModel, OpenFormCallback } from '../typings'

type FormState = {
  formOpen: boolean
  initialValues?: CustomFieldFormModel
}

export function useForm() {
  const [formState, setFormState] = useState<FormState>(() => ({
    formOpen: false,
  }))

  const openForm = useCallback<OpenFormCallback>(
    (initialValues) => setFormState({ formOpen: true, initialValues }),
    [],
  )

  const closeForm = useCallback(() => setFormState({ formOpen: false }), [])

  return {
    ...formState,
    openForm,
    closeForm,
  }
}
